import type { ComponentType } from 'svelte';
import type { ViewCategory, ViewVariant } from 'src/types/DeviceUI';

import RelayBasicView from './DeviceViews/Relay/RelayBasicView.svelte';
import RelayAdvancedView from './DeviceViews/Relay/RelayAdvancedView.svelte';
import FanBasicView from './DeviceViews/Fan/FanBasicView.svelte';
import FanAdvancedView from './DeviceViews/Fan/FanAdvancedView.svelte';
import SensorBasicView from './DeviceViews/Sensor/SensorBasicView.svelte';
import SensorAdvancedView from './DeviceViews/Sensor/SensorAdvancedView.svelte';
import LightBasicView from './DeviceViews/Light/LightBasicView.svelte';
import LightAdvancedView from './DeviceViews/Light/LightAdvancedView.svelte';
import PowerMeterBasicView from './DeviceViews/PowerMeter/PowerMeterBasicView.svelte';
import PowerMeterAdvancedView from './DeviceViews/PowerMeter/PowerMeterAdvancedView.svelte';
import EmeterBasicView from './DeviceViews/Emeter/EmeterBasicView.svelte';
import EmeterAdvancedView from './DeviceViews/Emeter/EmeterAdvancedView.svelte';
import RollerBasicView from './DeviceViews/Roller/RollerBasicView.svelte';
import RollerAdvancedView from './DeviceViews/Roller/RollerAdvancedView.svelte';
import BluetoothSensorBasicView from './DeviceViews/BluetoothSensor/BluetoothSensorBasicView.svelte';
import BluetoothSensorAdvancedView from './DeviceViews/BluetoothSensor/BluetoothSensorAdvancedView.svelte';
import InputsReaderBasicView from './DeviceViews/InputsReader/InputsReaderBasicView.svelte';
import InputsReaderAdvancedView from './DeviceViews/InputsReader/InputsReaderAdvancedView.svelte';
import RemoteControlBasicView from './DeviceViews/RemoteControl/RemoteControlBasicView.svelte';
import RemoteControlAdvancedView from './DeviceViews/RemoteControl/RemoteControlAdvancedView.svelte';
import PeripheralBasicView from './DeviceViews/PeripheralDevice/PeripheralBasicView.svelte';
import PeripheralAdvancedView from './DeviceViews/PeripheralDevice/PeripheralAdvancedView.svelte';
import PillSensorBasicView from 'src/components/ThePill/PillSensorBasicView.svelte';
import PillSensorAdvancedView from 'src/components/ThePill/PillSensorAdvancedView.svelte';

export interface ViewOption {
	category: ViewCategory;
	variant: ViewVariant;
	title: string;
	icon?: string;
}

export const deviceViewOptionsRegistry: Partial<Record<ViewCategory, ViewOption[]>> = {
	relay: [
		{ category: 'relay', variant: 'basic', title: 'Basic' },
		{ category: 'relay', variant: 'advanced', title: 'Advanced' },
	],
	fan: [
		{ category: 'fan', variant: 'basic', title: 'Basic' },
		{ category: 'fan', variant: 'advanced', title: 'Advanced' },
	],
	sensor: [
		{ category: 'sensor', variant: 'basic', title: 'Basic' },
		{ category: 'sensor', variant: 'advanced', title: 'Advanced' },
	],
	pill_sensor: [
		{ category: 'pill_sensor', variant: 'basic', title: 'Basic' },
		{ category: 'pill_sensor', variant: 'advanced', title: 'Advanced' },
	],
	light: [
		{ category: 'light', variant: 'basic', title: 'Basic' },
		{ category: 'light', variant: 'advanced', title: 'Advanced' },
	],
	power_meter: [
		{ category: 'power_meter', variant: 'basic', title: 'Basic' },
		{ category: 'power_meter', variant: 'advanced', title: 'Advanced' },
	],
	emeter: [
		{ category: 'emeter', variant: 'basic', title: 'Basic' },
		{ category: 'emeter', variant: 'advanced', title: 'Advanced' },
	],
	roller: [
		{ category: 'roller', variant: 'basic', title: 'Basic' },
		{ category: 'roller', variant: 'advanced', title: 'Advanced' },
	],
	bluetooth_sensor: [
		{ category: 'bluetooth_sensor', variant: 'basic', title: 'Basic' },
		{ category: 'bluetooth_sensor', variant: 'advanced', title: 'Advanced' },
	],
	inputs_reader: [
		{ category: 'inputs_reader', variant: 'basic', title: 'Basic' },
		{ category: 'inputs_reader', variant: 'advanced', title: 'Advanced' },
	],
	remote_control: [
		{ category: 'remote_control', variant: 'basic', title: 'Basic' },
		{ category: 'remote_control', variant: 'advanced', title: 'Advanced' },
	],
	peripheral_device: [
		{ category: 'peripheral_device', variant: 'basic', title: 'Basic' },
		{ category: 'peripheral_device', variant: 'advanced', title: 'Advanced' },
	],
};

export const viewComponentRegistry: Partial<
	Record<ViewCategory, Partial<Record<ViewVariant, ComponentType>>>
> = {
	relay: {
		basic: RelayBasicView,
		advanced: RelayAdvancedView,
	},
	fan: {
		basic: FanBasicView,
		advanced: FanAdvancedView,
	},
	sensor: {
		basic: SensorBasicView,
		advanced: SensorAdvancedView,
	},
	pill_sensor: {
		basic: PillSensorBasicView,
		advanced: PillSensorAdvancedView,
	},
	bluetooth_sensor: {
		basic: BluetoothSensorBasicView,
		advanced: BluetoothSensorAdvancedView,
	},
	light: {
		basic: LightBasicView,
		advanced: LightAdvancedView,
	},
	power_meter: {
		basic: PowerMeterBasicView,
		advanced: PowerMeterAdvancedView,
	},
	emeter: {
		basic: EmeterBasicView,
		advanced: EmeterAdvancedView,
	},
	roller: {
		basic: RollerBasicView,
		advanced: RollerAdvancedView,
	},
	inputs_reader: {
		basic: InputsReaderBasicView,
		advanced: InputsReaderAdvancedView,
	},
	remote_control: {
		basic: RemoteControlBasicView,
		advanced: RemoteControlAdvancedView,
	},
	peripheral_device: {
		basic: PeripheralBasicView,
		advanced: PeripheralAdvancedView,
	},
};
